// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"Default_audioPlayer__3vb2K","soundSwitch":"Default_soundSwitch__2nglg","pageMap":"Default_pageMap__Jnkwd","snsOuter":"Default_snsOuter__3UPwt"};